import React from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import logo from "./StMaryLogo.PNG";
import frd from "./Fr.DavidHanna.png";
import "./App.css";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Sidebar from "./Sidebar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import clsx from "clsx";
import Divider from "@material-ui/core/Divider";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
//#5e #38
const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#bda772",
    },
    secondary: {
      main: "#5e5e5e",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    textAlign: "center",
    width: "100%",
    fontFamily: "Futura",
  },
  title1: {
    textAlign: "center",
    width: "100%",
    color: "white",
    fontFamily: "Futura",
  },
  app_logo: {
    width: 100,
  },
}));

const LinkList = ({ title, links }) => {
  const classes = useStyles();

  return (
    <Grid item md={3} direction="column" style={{ height: "100%" }}>
      <Paper
        style={{
          height: "100%",
          paddingTop: 10,
          paddingRight: 20,
          paddingLeft: 20,
        }}
        elevation={5}
      >
        <Typography variant="h5" color="white" className={classes.title}>
          {title}
        </Typography>
        <div className="ButtonSt">
          <List>
            {links.map((link, i) => (
              <ListItem>
                <Button
                  style={{
                    width: "100%",
                    margin: "auto",
                    fontFamily: "Futura",
                    color: "white",
                    justifyContent: "initial",
                  }}
                  variant="contained"
                  color="primary"
                  href={link.link}
                >
                  {
                    <img
                      src={link.pic}
                      style={{
                        paddingRight: 20,
                        height: 40,
                        flexDirection: "row",
                      }}
                      className="ButtonSt"
                    />
                  }
                  <header className="ButtText">{link.name}</header>
                </Button>
              </ListItem>
            ))}
          </List>
        </div>
      </Paper>
    </Grid>
  );
};

const LinkList1 = ({ title, links }) => {
  const classes = useStyles();

  return (
    <Grid
      item
      direction="column"
      style={{
        height: "100%",
        width: "100%",
        marginTop: "auto",
        marginBottom: "auto",
      }}
    >
      <Paper
        style={{
          flex: 1,
          height: "100%",
          width: "100%",
          padding: 15,
          backgroundColor: "#ffeacc",
          borderRadius: 10,
        }}
        elevation={5}
      >
        <Typography variant="h5" className={classes.title1}>
          {title}
        </Typography>
        <div className="ButtonSt">
          <List>
            {links.map((link, i) => (
              <ListItem>
                <Button
                  style={{
                    width: "100%",
                    margin: "auto",
                    fontFamily: "Futura",
                    color: "white",
                    justifyContent: "initial",
                  }}
                  variant="contained"
                  color="primary"
                  href={link.link}
                >
                  {
                    <img
                      src={link.pic}
                      style={{ paddingRight: 20, height: 40 }}
                      className="ButtonSt"
                    />
                  }
                  <header className="ButtText">{link.name}</header>
                </Button>
              </ListItem>
            ))}
          </List>
        </div>
      </Paper>
    </Grid>
  );
};

function App() {
  const classes = useStyles();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const fiveL = [
    {
      name: "Donate",
      link: "https://checkout.square.site/merchant/MLNE51939E244/checkout/4YZVXK2CAWGC4HXIRJC6VIV5",
      pic: require("./Donate.png"),
    },
  ];
  const name1 = [
    {
      name: "St. Mary",
      link: "https://www.youtube.com/watch?v=vOuRSgycUxI",
      pic: require("./Youtube.png"),
    },
    {
      name: "AMC",
      link: "https://www.youtube.com/watch?v=frIcgcSpkaw",
      pic: require("./Youtube.png"),
    },
    {
      name: "Fr. David",
      link: "https://www.youtube.com/channel/UCWRYbU8HvSS7FQDxS5Bp_NA?view_as=subscriber",
      pic: require("./Youtube.png"),
    },
  ];
  const name2 = [
    {
      name: "Fr. David's YouTube",
      link: "https://www.youtube.com/channel/UCWRYbU8HvSS7FQDxS5Bp_NA?view_as=subscriber",
      pic: require("./Youtube.png"),
    },
    {
      name: "Confession",
      link: "https://calendly.com/fr-davidhanna/20min",
      pic: require("./Conf.png"),
    },
    {
      name: "My Contact Info",
      link: "https://dot.cards/frdavidhanna",
      pic: require("./Email.png"),
    },
    {
      name: "Phone Number",
      link: "tel:(317) 531-5774",
      pic: require("./Phone.png"),
    },
    {
      name: "Church Website",
      link: "https://www.stmaryofchicago.org/",
      pic: require("./SMC.png"),
    },
  ];

  return (
    <ThemeProvider theme={darkTheme}>
      <Paper
        style={{
          padding: 10,
          //backgroundColor: "#5e5e5e",
          backgroundColor: "#F9F6F0",
          height: "100%",
          alignContent: "center",
          alignItems: "center",
          justify: "center",
          justifyContent: "center",
          justifyItems: "center",
        }}
        elevation={0}
      >
        <header className="nig" style={{ borderRadius: 10, padding: 10 }}>
          <div className="nigcont">
            <img
              src={logo}
              className={classes.app_logo}
              style={{ paddingRight: 20 }}
              alt="stmary_chicago"
            />
            <Typography variant="h6" className={classes.title}>
              St. Mary's Coptic Orthodox Church of Chicago
            </Typography>
          </div>
        </header>

        <Grid
          style={{ paddingTop: 40, paddingBottom: 20 }}
          xs={12}
          md={12}
          className="frdcont"
        >
          <Grid
            container
            spacing={1}
            style={{
              backgroundColor: "#BDBDB4",
              height: "100%",
              borderRadius: 10,
              padding: 30,
              alignContent: "space-between",
            }}
            md={6}
            align={"space-between"}
            className="frdcont1"
          >
            <Typography
              style={{
                fontFamily: "Futura",
                textAlign: "center",
                paddingBottom: 20,
                fontSize: 30,
                display: "block",
                width: "100%",
                textAlign: "center",
                color: "white",
              }}
            >
              Fr. David Hanna{ }
            </Typography>
            <Grid item style={{ borderRadius: 10 }} md={6} className="frdcont1">
              <img src={frd} className="frdpic2" />
            </Grid>
            <Grid item md={12} className="frdfrd">
              <Paper
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  paddingTop: 15,
                  paddingBottom: 10,
                  borderRadius: 10,
                  marginTop: 20,
                  backgroundColor: "#434745",
                }}
              >
                <Typography variant="h5" className={classes.title1}>
                  My Info
                </Typography>
                <div>
                  <List>
                    {name2.map((link, i) => (
                      <ListItem>
                        <Button
                          style={{
                            width: "90%",
                            backgroundColor: "#BDA672",
                            margin: "auto",
                            fontFamily: "Futura",
                            color: "white",
                            justifyContent: "initial",
                          }}
                          variant="contained"
                          href={link.link}
                        >
                          {
                            <img
                              src={link.pic}
                              style={{ paddingRight: 20, height: 40 }}
                            />
                          }
                          <header className="ButtText">{link.name}</header>
                        </Button>
                      </ListItem>
                    ))}
                  </List>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <header
          className={classes.title}
          style={{
            fontSize: 30,
            paddingBottom: 10,
            paddingTop: 30,
            color: "black",
          }}
        >
          Latest Sermons
        </header>
        <div className="nig3" style={{ paddingBottom: 40 }}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/videoseries?list=PLjkPMgbKTyGjeG7lytuydh5G0RFOgX5Xj"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>

        <header
          className={classes.title}
          style={{
            fontSize: 30,
            paddingBottom: 10,
            paddingTop: 30,
            color: "black",
          }}
        >
          Latest Posts
        </header>
        <header className="nig3" style={{ paddingBottom: 50 }}>
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffrdavidhanna&tabs=timeline&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId"
            width="340"
            height="500"
            style={{}}
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
        </header>

        <header
          className={classes.title}
          style={{
            fontSize: 30,
            paddingBottom: 10,
            paddingTop: 30,
            color: "black",
          }}
        >
          Links
        </header>
        <Grid
          container
          spacing={2}
          justify="center"
          style={{ paddingBottom: 50 }}
        >
          <LinkList title="5 Loaves Food Pantry" links={fiveL} />
        </Grid>
      </Paper>
      <footer className="Footer">
        <h4 className="Footer-Text">
          {<img src={logo} style={{ height: 60, paddingRight: 20 }} />}© Fr.
          David Hanna - St. Mary's Coptic Orthodox Church of Chicago
        </h4>
      </footer>
    </ThemeProvider>
  );
}

export default App;
